<template>
    <div class="p-2 w-50 d-flex" @click="batchClicked">
        <div class="rounded border p-2 clickable flex-1" :class="if_active_class">
            <div class="d-flex">
                <div class="flex-1">
                    <div class="flex-1"><strong>{{batch.location && batch.location.primary_company ? batch.location.primary_company.name : ''}}</strong></div>
                    <div class="d-flex justify-content-between" style="margin-bottom: 2px;">
                        <div class="flex">{{batch.location.name}}</div>
                        <div class="flex">
                            <button class="rounded btn btn-outline-primary btn-sm " @click="updateLocation" style="line-height: 1;">Ändra</button>
                        </div>
                    </div>
                  <div class="d-flex justify-content-between" style="margin-bottom: 2px;">
                    <div class="flex">{{batch.location.city.name}}</div>
                  </div>
                    <div class="d-flex justify-content-between" style="margin-bottom: 2px;">
                        <div class="flex">{{batch.therapist.user.name}}</div>
                        <div class="flex">
                            <button class="rounded btn btn-outline-primary btn-sm " @click="updateTherapist" style="line-height: 1;">Ändra</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between" style="margin-bottom: 2px;">
                        <div class="flex">Period: {{getPeriod()}}</div>
                        <div class="flex">
                            <button class="rounded btn btn-outline-primary btn-sm " @click="updatePeriod" style="line-height: 1;" :disabled="batch.weeks_between == 0">Ändra</button>
                        </div>
                    </div>

                    <div class="flex-1">Tidsintervall: {{batch.day_start}} - {{batch.day_end}}</div>
                    <div class="d-flex justify-content-between">
                        <div class="flex">Veckodagar: {{weekdays()}}</div>
                        <div class="flex">
                            <button class="rounded btn btn-outline-primary btn-sm " @click="updateWeekdays" style="line-height: 1;" :disabled="batch.weeks_between == 0">Ändra</button>
                        </div>
                    </div>
                    <div class="flex-1">Antal behandlingar: {{batch.day_amount}}</div>
                    <div v-if="batch.weeks_between > 0" class="flex-1">Veckointervall: {{intervalName(batch.weeks_between)}}</div>
                </div>

                <div class="d-flex ml-1">
                    <img class="round-profile-picture align-self-center" :src="'/therapist_profile_picture/'+batch.therapist.profile_picture_path">
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "BatchesPanelSlot",
        props: ['batch', 'width_class', 'currentlyActiveBatch', 'currentDate'],
        data: function () {
            return {
                weekdaysArr: [
                    'Söndag',
                    'Måndag',
                    'Tisdag',
                    'Onsdag',
                    'Torsdag',
                    'Fredag',
                    'lördag'
                ]
            };
        },
        computed: {
            calc_class () {
                return this.width_class + this.if_active_class;
            },
            if_active_class () {
                if (this.currentlyActiveBatch && this.batch.id == this.currentlyActiveBatch.id) {
                    return " active-batch";
                }

                return "";
            },
        },
        methods: {
            intervalName(weeks_between) {
                switch(weeks_between) {
                    case 1:
                        return 'Varje vecka';
                    case 2:
                        return 'Varannan vecka';
                    case 3:
                        return 'Var tredje vecka';
                    case 4:
                        return 'Var fjärde vecka';
                }
            },
            batchClicked () {
                this.$emit('selected', {
                    batch: this.batch,
                });
            },
            getPeriod() {
                let start = null;
                let end = null;

                try {
                    start = new Date(this.batch.first_scheduled_day.split('T')[0]);
                    end = new Date(this.batch.last_scheduled_day.split('T')[0]);
                } catch(e) {
                    console.error(e);
                }

                return (start ? start.toISOString().split('T')[0] : '????-??-??') + ' - ' + (end ? end.toISOString().split('T')[0] : '????-??-??');
            },
            weekdays() {
                if(this.batch.weekdays === 'alla') {
                    return this.batch.weekdays;
                } else {
                    let self = this;
                    let test = '';
                    let days = this.batch.weekdays.split(',');

                    days.forEach(day => test += self.weekdaysArr[day] + ' ');
                    return test;
                }
            },
            updateLocation(e) {
                e.stopPropagation();

                let changeLocationModal = $("#change-location-modal");
                let removeDayModalTherapistHidden = $("#add-schedule-modal-therapist-hidden");
                let changeLocationModalBatchHidden = $("#change-location-modal-batch-hidden");
                let changeLocationModalDate = $("#change-location-modal-date");

                changeLocationModalDate.val(moment(this.currentDate).format('YYYY-MM-DD'));
                $("#change-location-modal-company-hidden").text()
                changeLocationModalBatchHidden.val(this.batch.id)[0].dispatchEvent(new Event('input'));
                removeDayModalTherapistHidden.text(this.batch.therapist_id);
                changeLocationModal.modal("show");
            },
            updateTherapist(e) {
                e.stopPropagation();

                let changeTherapistModal = $("#change-therapist-modal");
                let removeDayModalTherapistHidden = $("#add-schedule-modal-therapist-hidden");
                let changeTherapistModalBatchHidden = $("#change-therapist-modal-batch-hidden");
                let changeTherapistModalDate = $("#change-therapist-modal-date");

                changeTherapistModalDate.val(moment(this.currentDate).format('YYYY-MM-DD'));
                $("#change-therapist-modal-company-hidden").text()
                changeTherapistModalBatchHidden.val(this.batch.id)[0].dispatchEvent(new Event('input'));
                removeDayModalTherapistHidden.text(this.batch.therapist_id);
                changeTherapistModal.modal("show");
            },
            updatePeriod(e) {
                e.stopPropagation();

                let changePeriodModal = $("#change-period-modal");
                let changePeriodModalBatchHidden = $("#change-period-modal-batch-hidden");
                let changePeriodModalDate = $("#change-period-modal-date");

                changePeriodModalDate.val(moment(this.currentDate).format('YYYY-MM-DD'));
                changePeriodModalBatchHidden.val(this.batch.id)[0].dispatchEvent(new Event('input'));
                changePeriodModal.modal("show");
            },
            updateWeekdays(e) {
                e.stopPropagation();

                let changeWeekdaysModal = $("#change-weekdays-modal");
                let changeWeekdaysModalBatchHidden = $("#change-weekdays-modal-batch-hidden");
                let changeWeekdaysModalDate = $("#change-weekdays-modal-date");

                changeWeekdaysModalDate.val(moment(this.currentDate).format('YYYY-MM-DD'));
                $("#change-therapist-modal-company-hidden").text()
                changeWeekdaysModalBatchHidden.val(this.batch.id)[0].dispatchEvent(new Event('input'));
                changeWeekdaysModal.modal("show");
            },
            showChangeLocationModal: function () {
                let changeLocationModal = $("#change-location-modal");
                let changeLocationModalDate = $("#change-location-modal-date");
                let changeLocationModalBatchHidden = $("#change-location-modal-batch-hidden");
                changeLocationModalBatchHidden.val(this.batch.id);
                document.getElementById("change-location-modal-batch-hidden").dispatchEvent(this.injectEvent);
                changeLocationModalDate.text(this.currentDate.format('YYYY-MM-DD'));
                changeLocationModal.modal("show");
            },
        },
        created() {

        }
    }
</script>

<style scoped>
    .active-batch {
        background-color: #ecf6f9;
    }
</style>
